import { fabric } from "fabric";

export default (function() {
  function Square(canvas, fillColor, strokeColor, strokeWidth) {
    this.canvas = canvas;
    this.className = "Square";
    this.isDrawing = false;
    this.fillColor = fillColor || "#FFFFFF";
    this.strokeColor = strokeColor || "#000000";
    this.strokeWidth = strokeWidth || 2;
    this.canvas.selection = false;
    this.origX = null;
    this.origY = null;
    this.bindEvents();
  }

  Square.prototype.bindEvents = function() {
    this.canvas.on("mouse:down", (o) => {
      this.onMouseDown(o);
    });

    this.canvas.on("mouse:move", (o) => {
      this.onMouseMove(o);
    });

    this.canvas.on("mouse:up", (o) => {
      this.onMouseUp(o);
    });

    this.canvas.on("object:moving", () => {
      this.disable();
    });
  };

  Square.prototype.onMouseUp = function() {
    this.canvas.renderAll();
    this.disable();
  };

  Square.prototype.onMouseMove = function(o) {
    if (!this.isEnable()) {
      return;
    }

    var pointer = this.canvas.getPointer(o.e);
    var activeObj = this.canvas.getActiveObject();

    if (this.origX > pointer.x) {
      activeObj.set({
        left: Math.abs(pointer.x)
      });
    }

    if (this.origY > pointer.y) {
      activeObj.set({
        top: Math.abs(pointer.y)
      });
    }

    activeObj.set({
      width: Math.abs(this.origX - pointer.x)
    });

    activeObj.set({
      height: Math.abs(this.origY - pointer.y)
    });

    activeObj.setCoords();
    this.canvas.renderAll();
  };

  Square.prototype.onMouseDown = function(o) {
    this.enable();
    var pointer = this.canvas.getPointer(o.e);

    this.origX = pointer.x;
    this.origY = pointer.y;

    const square = new fabric.Rect({
      stroke: this.strokeColor,
      fill: this.fillColor,
      selectable: true,
      left: this.origX,
      top: this.origY,
      originX: "left",
      originY: "top",
      strokeWidth: this.strokeWidth,
      width: pointer.x - this.origX,
      height: pointer.y - this.origY,
      angle: 0
    });

    this.canvas.add(square).setActiveObject(square);
  };

  Square.prototype.isEnable = function() {
    return this.isDrawing;
  };

  Square.prototype.enable = function() {
    this.isDrawing = true;
  };

  Square.prototype.disable = function() {
    this.isDrawing = false;
    this.canvas.discardActiveObject().renderAll();
  };

  return Square;
})();